module.exports = __webpack_public_path__ + "static/img/integrity.4115fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/assets/integrity.png
// module id = UjSX
// module chunks = 1